
<div class="login-page">
  <div class="row align-center align-middle login-page__content">
    <gw-login class="columns small-12 medium-6 large-4" (logIn)="onLogIn($event)"></gw-login>
  </div>
</div>